import Seo from "../components/Seo";

const SECTIONS = [
  {
    h: "Who's responsible for your data",
    p: [
      "HiredToday is operated by Centego Logistics Ltd, registered in England & Wales. Centego Logistics Ltd is the data controller for the personal data collected through this site, under UK GDPR and the Data Protection Act 2018.",
      "You can reach us about anything in this policy through the contact page.",
    ],
  },
  {
    h: "What we collect",
    p: [
      "If you create an account: your name, email address, password (stored only as a secure hash), account type, and. For employers. Your company name.",
      "If you're a jobseeker and you fill in your profile or apply for a job: your phone number, location, cover note and any CV or profile link you choose to share.",
      "If you're an employer and you pay for a listing: payment is handled entirely by Stripe. We receive confirmation and the amount paid, but never your card details.",
      "Like most sites, our servers record standard technical logs (IP address, browser type, pages visited) for security and troubleshooting.",
    ],
  },
  {
    h: "Visitor analytics",
    p: [
      "We record which pages are viewed and when, the approximate location (town or city level, derived from your IP address), the device type, and how you arrived (for example a search engine or a link in an email). Your IP address itself is never stored, visitors are recognised by a one-way code that cannot be reversed back to an address.",
      "If you're signed in, page visits are linked to your account so we can support you and improve the site. Analytics are used only to run and grow HiredToday, never for advertising, and never shared with or sold to third parties.",
    ],
  },
  {
    h: "What we use it for",
    p: [
      "To run your account, show your applications to the employers you choose, let employers manage their listings and applicants, take payment for paid listings, and keep the site secure.",
      "Our legal bases are: performing the contract you have with us (running your account and listings), legitimate interests (keeping the board safe and genuine), and legal obligation (records for tax and accounting).",
      "We do not sell your data. We do not share jobseeker profiles with anyone except the employers you apply to. We do not send marketing emails you haven't asked for.",
    ],
  },
  {
    h: "Who we share it with",
    p: [
      "Employers you apply to receive the application details you submit.",
      "Stripe processes payments. Our hosting and database providers process data on our behalf under contract. That's the full list. No advertisers, no data brokers.",
    ],
  },
  {
    h: "How long we keep it",
    p: [
      "Account data is kept while your account is active. Job applications are kept while the related listing is active, and removed when the listing is deleted. Payment records are kept for six years to meet UK tax and accounting rules. Server logs are kept for up to 90 days.",
    ],
  },
  {
    h: "Your rights",
    p: [
      "Under UK GDPR you can ask us for a copy of your data, have it corrected or deleted, object to or restrict how we use it, and ask for it in a portable format. To use any of these rights, contact us. We'll handle it within one month.",
      "If you're not happy with how we handle your data, you can complain to the Information Commissioner's Office (ICO) at ico.org.uk. We'd appreciate the chance to put things right first.",
    ],
  },
  {
    h: "Security",
    p: [
      "Passwords are stored as bcrypt hashes, sessions use encrypted connections (HTTPS) and httpOnly cookies, and access to systems is limited to those who need it. No system is perfectly secure, but we take reasonable, proportionate measures and will tell you and the ICO if a breach puts your rights at risk.",
    ],
  },
];

export default function Privacy() {
  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20" data-testid="privacy-page">
      <Seo
        title="Privacy Policy | HiredToday"
        description="How HiredToday (operated by Centego Logistics Ltd) collects, uses and protects your personal data under UK GDPR."
        path="/privacy"
      />
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-3">Legal</p>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tighter font-black text-zinc-950">Privacy policy</h1>
      <p className="mt-3 text-sm text-zinc-500">Last updated: August 2026</p>
      <p className="mt-6 text-base text-zinc-600 leading-relaxed">
        The short version: we collect what we need to run the job board, we never sell your data, and your applications go only to the employers you choose. The longer version, in plain English, is below.
      </p>
      <div className="mt-10 space-y-10">
        {SECTIONS.map((s, i) => (
          <section key={s.h} data-testid={`privacy-section-${i}`}>
            <h2 className="font-display text-xl font-bold text-zinc-950 mb-3">{i + 1}. {s.h}</h2>
            {s.p.map((para) => (
              <p key={para.slice(0, 40)} className="text-sm text-zinc-600 leading-relaxed mt-3">{para}</p>
            ))}
          </section>
        ))}
      </div>
    </main>
  );
}
